export const UserRole = {
    MedicalAssistant: 1,
    Doctor: 2,
    Admin: 3,
    Accounting: 5,
} as const;

export const isAdmin      = (role: number | undefined): boolean => role === UserRole.Admin;
export const isDoctor     = (role: number | undefined): boolean => role === UserRole.Doctor;
export const isAccounting = (role: number | undefined): boolean => role === UserRole.Accounting;
export const isStandard   = (role: number | undefined): boolean =>
    role === UserRole.MedicalAssistant || role === UserRole.Accounting;

type BankPerms = { userRights?: number; permBank?: boolean; permBankReconcile?: boolean } | undefined;

/** Doctor/Admin always see their own bank account (fixed, like their own invoices); staff only
 *  with an explicit permBank grant. Mirrors requireBank on the backend. */
export const canSeeBank = (doctor: BankPerms): boolean =>
    isDoctor(doctor?.userRights) || isAdmin(doctor?.userRights) || doctor?.permBank === true;

/** Doctor/Admin always match on their own account; staff only with permBankReconcile.
 *  Mirrors requireBankReconcile on the backend. */
export const canReconcileBank = (doctor: BankPerms): boolean =>
    isDoctor(doctor?.userRights) || isAdmin(doctor?.userRights) || doctor?.permBankReconcile === true;
